import classNames from 'classnames';

import Section from '../../components/Section';
import { marginsSecondaryClassNames } from '../../utils/style';
import { experienceTitleClassNames } from './Experience';

const SectionExpPageRest = () => (
  <Section>
    <h3 className={classNames(experienceTitleClassNames, 'mb-4 text-center')}>Autres missions</h3>
    <p className={marginsSecondaryClassNames}>
      J'ai précédemment eu l'opportunité d'intervenir auprès de grandes entreprises durant des missions en ESN aux contextes métier et
      techniques variés : Challenges / Sciences & Avenir (Node.js), Les Mousquetaires (AngularJS), L'Équipe (Backbone), Pages Jaunes et SFR.
    </p>
  </Section>
);

export default SectionExpPageRest;
